import { useEffect, useState } from "react";

type StatusIndicator = "none" | "minor" | "major" | "critical";

interface AirtableStatus {
	indicator: StatusIndicator | null;
	description: string;
}

const POLL_INTERVAL = 60_000;

export function useAirtableStatus(): AirtableStatus {
	const [status, setStatus] = useState<AirtableStatus>({ indicator: null, description: "Loading..." });

	useEffect(() => {
		const fetchStatus = async () => {
			try {
				const res = await fetch("https://status.airtable.com/api/v2/status.json");
				const data = await res.json();
				setStatus({
					indicator: data.status.indicator as StatusIndicator,
					description: data.status.description,
				});
			} catch {
				setStatus({ indicator: null, description: "Unable to fetch status" });
			}
		};

		fetchStatus();
		const interval = setInterval(fetchStatus, POLL_INTERVAL);
		return () => clearInterval(interval);
	}, []);

	return status;
}
